<template>
    <div>
        <div v-for="changeLog in changeLogs"
             v-if="hasVisibleImages(changeLog)"
             :key="changeLog.id"
             :class="showLogDetails ? 'card mb-3' : ''">
            <div :class="showLogDetails ? 'card-body' : ''">
                <div v-if="showLogDetails"
                     class="d-flex justify-content-between align-items-center">
                    <div class="comment-meta d-flex align-items-center small font-weight-bold">
                        <span class="mr-2" v-text="changeLogTime(changeLog)"></span>
                        <span v-text="changeLogDate(changeLog)"></span>
                    </div>
                    <div class="comment-created_by" v-text="changeLog.user.name"></div>
                </div>

                <div class="row">
                    <div
                        v-for="(img, idx) in changeLog.attachments"
                        v-if="showRedundantPictures || !isImageInMarking(img)"
                        :key="idx"
                        class="d-flex justify-content-center align-items-center mb-3"
                        :class="cardClass">
                        <div class="card shadow-sm rounded bg-white position-relative attachment-card">
                            <!-- Alternative: show image with disabled button instead of hiding it:
                            <b-button
                                v-if="showControls"
                                class="position-absolute rounded-circle p-0 attachment-circle"
                                :class="{ 'btn-disabled': isImageInMarking(img) }"
                                @click="restoreAttachment(img)"
                                v-b-tooltip.hover
                                title="Move to Selected Pictures">
                                <b-icon-arrow-up-left-circle></b-icon-arrow-up-left-circle>
                            </b-button> -->
                            <b-button
                                v-if="showControls"
                                class="position-absolute rounded-circle p-0 attachment-circle"
                                :disabled="restoringIds.includes(img.media_id)"
                                @click="restoreAttachment(img)"
                                v-b-tooltip.hover
                                title="Move to Selected Pictures">
                                <b-icon-arrow-up-left-circle></b-icon-arrow-up-left-circle>
                            </b-button>

                            <div class="image-wrapper" @click="openImage(img)">
                                <img
                                    class="img-fluid rounded w-100 h-100"
                                    :src="img.attachment"
                                    alt="attachment"
                                    style="object-fit: cover;"
                                />

                                <div class="image-overlay">
                                    <b-icon-zoom-in class="overlay-icon"></b-icon-zoom-in>
                                </div>
                            </div>
                            <p v-if="img.description || img.is_before || img.is_after"
                               class="mb-0 text-muted text-center position-absolute w-100 attachment-description"
                            >{{ attachmentLabel(img) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import moment from "moment";

export default {
    name: 'ChangeLogAttachments',
    props: {
        showRedundantPictures: {
            type: Boolean,
            default: true,
        },
        showLogDetails: {
            type: Boolean,
            default: true,
        },
        showControls: {
            type: Boolean,
            default: true,
        },
        cardClass: {
            type: String,
            default: "col-12 col-sm-4"
        },
        restoringIds: {
            type: Array,
            default: () => []
        },
        changeLogs: [],
        marking: {
            required: true,
            type: Object,
            default: {}
        },
    },
    components: {},
    computed: {},
    mounted() {
    },
    data() {
        return {
            commentText: ''
        }
    },
    methods: {
        attachmentLabel(attachment) {
            const prefix = attachment.is_before ? 'Image Before. '
                         : attachment.is_after  ? 'Image After. '
                         : '';
            return prefix + (attachment.description || '');
        },

        openImage(attachment) {
            this.$emit('open-image', attachment)
        },

        restoreAttachment(img) {
            this.$emit('restore-attachment', img);
        },

        isImageInMarking(img) {
            if (!this.marking || !this.marking.attachments) return false;
            return this.marking.attachments.some(att => att.hash === img.hash);
        },

        hasVisibleImages(changeLog) {
            if (this.showRedundantPictures) return (changeLog.attachments || []).length > 0;
            return (changeLog.attachments || []).some(img => !this.isImageInMarking(img));
        },

        changeLogTime(changeLog) {
            let changeLogDate = moment(changeLog.created_at);
            return changeLogDate.format('HH:mm')
        },
        changeLogDate(changeLog) {
            let changeLogDate = moment(changeLog.created_at);
            return changeLogDate.format('DD.MM.YYYY')
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.image-dimmed {
    opacity: 0.3;
}

.btn-overlay {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 4px;
}

.img-attachment {
    object-fit: cover;
    top: 0;
    left: 0;
}

</style>
